export const C = {
  bg: "#0a0f0f",
  bgCard: "#0f1a1a",
  bgCard2: "#0d1515",
  teal: "#00c9b1",
  tealDark: "#007a6e",
  tealLight: "rgba(0,201,177,0.1)",
  tealGlow: "rgba(0,201,177,0.1)",
  accent: "#e0fff9",
  accentMid: "#7ffff0",
  text: "#cce8e4",
  textMuted: "#5a8a84",
  textDim: "#3a6060",
  border: "rgba(0,201,177,0.18)",
  borderHover: "rgba(0,201,177,0.45)",
  navBg: "rgba(10,15,15,0.92)",
  shadow: "none",
  shadowHover: "0 6px 28px rgba(0,201,177,0.08)",
};

export const HF = "'Cormorant Garamond', 'Palatino Linotype', Georgia, serif";
export const BF = "'Nunito', 'Segoe UI', sans-serif";
